import { render, staticRenderFns } from "./PrintCertificates.vue?vue&type=template&id=27cab74f"
import script from "./PrintCertificates.vue?vue&type=script&lang=js"
export * from "./PrintCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports